// import { useRef } from 'react'; // No se usa actualmente
import { useGeolocation } from '../../../hooks/useGeolocation';

interface UseGeolocalizacionSilenciosaReturn {
  ubicacionActual: { lat: number; lng: number } | null;
  errorUbicacion: string | null;
  startLocationTracking: () => Promise<void>;
  stopLocationTracking: () => void;
  isTracking: boolean;
}

/**
 * Hook para geolocalización silenciosa
 * Captura la ubicación automáticamente sin mostrar UI
 * Solo expone la ubicación actual y errores
 */
export const useGeolocalizacionSilenciosa = (): UseGeolocalizacionSilenciosaReturn => {
  const { 
    coords: ubicacionActual, 
    error: errorUbicacion, 
    // loading: loadingUbicacion, // No se usa en este hook 
    startLocationTracking,
    stopLocationTracking,
    isTracking
  } = useGeolocation();

  // Removidos los logs innecesarios

  return {
    ubicacionActual,
    errorUbicacion,
    startLocationTracking,
    stopLocationTracking,
    isTracking
  };
};

